/* wofp-page.js  Product page glue, stages 1 and 2.  Engine 2026-10-22pg6

   What it does right now: paints the rating under the title.

   WHERE THE RATING COMES FROM. Section 6 (#wofp-proof) already fetches this
   product's Judge.me reviews and paints "4.9 out of 5, across 148 reviews" into
   #wofpj-agg. That section is the one owner of the Judge.me feed, so this file
   never talks to Judge.me itself: it watches #wofpj-agg, copies the number and
   the count up to the title, and remembers them for this product in
   sessionStorage so the next visit paints the badge at once instead of waiting
   for the feed. If section 6 is missing or finds no reviews, the badge simply
   stays hidden. Nothing here can show a number the page below does not show.

   Later stages add the sticky bar and the folds to this same file. */
(function () {
'use strict';
if (window.wofpPage) return;
window.wofpPage = '2026-10-22pg6';

var root = document.getElementById('wofpb');
if (!root) return;
var badge = document.getElementById('wofp-rate');
var numEl = document.getElementById('wofp-rate-num');
var nEl = document.getElementById('wofp-rate-n');
if (!badge || !numEl || !nEl) return;

var KEY = 'wofp_rate_' + (root.getAttribute('data-diet') || 'x');

function paint(avg, count) {
  var a = Number(avg);
  if (!(a > 0 && a <= 5)) return false;
  numEl.textContent = a.toFixed(1);
  nEl.textContent = count ? count + ' reviews' : '';
  badge.setAttribute('aria-label', 'Rated ' + a.toFixed(1) + ' out of 5' + (count ? ' from ' + count + ' reviews' : '') + '. Read the reviews');
  var stars = badge.querySelectorAll('.wofp-rate__stars i');
  var on = Math.round(a);
  for (var i = 0; i < stars.length; i++) stars[i].className = i < on ? 'is-on' : '';
  badge.hidden = false;
  return true;
}

/* remembered from the last visit, so there is no wait */
try {
  var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
  if (c && c.a) paint(c.a, c.n);
} catch (e) {}

/* then the live number from section 6, whenever it lands */
var agg = document.getElementById('wofpj-agg');
function lift() {
  if (!agg || agg.hidden) return false;
  var num = document.getElementById('wofpj-agg-num');
  var lab = document.getElementById('wofpj-agg-lab');
  var stars = document.getElementById('wofpj-agg-stars');
  if (!num || !lab) return false;
  if (stars && stars.hidden) return false;            /* count only, no average: no badge */
  var a = parseFloat(num.textContent);
  var n = '';
  var bold = lab.querySelector('.wofpj-agg__n');
  if (bold && /across/.test(lab.textContent)) n = bold.textContent.trim();
  if (!paint(a, n)) return false;
  try { sessionStorage.setItem(KEY, JSON.stringify({ a: a, n: n, t: Date.now() })); } catch (e) {}
  return true;
}
if (agg) {
  if (!lift() && window.MutationObserver) {
    var mo = new MutationObserver(function () { if (lift()) mo.disconnect(); });
    mo.observe(agg, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true, characterData: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }
}

/* the badge links to the reviews; scroll there smoothly and let the browser
   fall back to the plain anchor if anything is odd */
badge.addEventListener('click', function (ev) {
  var target = document.getElementById('wofp-proof');
  if (!target || !target.scrollIntoView) return;
  ev.preventDefault();
  try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { target.scrollIntoView(); }
});

/* ---- BEAT 1 (stage 3): the fit question names the dog ------------------
   "Is this right for your dog?" becomes "Is this right for Ripley?" once the
   dog is known. Text only; the section's own logic is untouched. */
(function () {
  var t = document.getElementById('wofpf-title');
  if (!t) return;
  var orig = t.innerHTML;
  function nameIt() {
    var d = window.wofpDog ? window.wofpDog() : null;
    var nm = d && d.name ? String(d.name).replace(/[&<>"]/g, '') : '';
    var html = nm ? orig.replace(/your dog/i, nm) : orig;
    if (t.innerHTML !== html) t.innerHTML = html;
  }
  nameIt();
  document.addEventListener('wyn:dog', function () { setTimeout(nameIt, 50); });
})();

/* ---- THE DETAIL ROWS (stage 6) -------------------------------------------
   The nutrition section, its questions, and the rotate section fold into three
   closed rows so the page reads buy box, fit, bowl, plan, reviews, and then
   "for the detail readers". Nothing is removed: the sections' own markup is
   moved whole into each row, with their scripts already bound, so the switch,
   the tabs and the rotation picker keep working exactly as before. A link to
   anything inside a closed row (the Fresh Rx "why" link goes to #wofpq) opens
   that row first. EVERY WORD THE ROWS SHOW IS IN THE TABLE BELOW. */
var ROWS = {
  numbersTitle: 'The numbers',
  numbersSub: 'per 1,000 kcal · guaranteed analysis · every vitamin, mineral and amino acid',
  numbersFacts: 'Calorie density: {kg} kcal per kg, about {cup} per cup.',
  questionsSub: '{n} questions',
  bowlTitle: 'What\u2019s in it',
  bowlSub: '{n} whole foods, cooked separately',
  bowlSubPlain: 'every ingredient, and why it is there',
  planTitleFor: '{name}\u2019s plan',
  planTitle: 'Your plan',
  rotateTitle: 'Rotate with other recipes',
  rotateSub: '{np} proteins · {nw} whole foods · pick the ones you would rotate'
};
function fill(t, m) { for (var k in m) t = t.split('{' + k + '}').join(m[k]); return t; }
function fold(id, title, sub, kids) {
  var d = document.createElement('details');
  d.className = 'wofp-fold'; d.id = id;
  var sm = document.createElement('summary');
  sm.className = 'wofp-fold__sum';
  var tt = document.createElement('span'); tt.className = 'wofp-fold__t'; tt.textContent = title;
  var ss = document.createElement('span'); ss.className = 'wofp-fold__s'; ss.textContent = sub || '';
  var ic = document.createElement('span'); ic.className = 'wofp-fold__ic'; ic.setAttribute('aria-hidden', 'true');
  var tx = document.createElement('span'); tx.className = 'wofp-fold__tx'; tx.appendChild(tt); if (sub) tx.appendChild(ss);
  sm.appendChild(tx); sm.appendChild(ic);
  var body = document.createElement('div'); body.className = 'wofp-fold__body';
  d.appendChild(sm); d.appendChild(body);
  kids[0].parentNode.insertBefore(d, kids[0]);
  for (var i = 0; i < kids.length; i++) body.appendChild(kids[i]);
  return d;
}
function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }
(function () {
  var nut = document.getElementById('wofp-nutrition');
  if (nut && nut.firstElementChild && !document.getElementById('wofp-fold-numbers')) {
    var inner = nut.firstElementChild, before = [], faq = null;
    var kids = Array.prototype.slice.call(inner.children);
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k.tagName === 'SCRIPT' || k.tagName === 'STYLE') continue;
      if (k.id === 'wofpq' || k.classList.contains('wofpq')) { faq = k; continue; }
      if (!faq) before.push(k);
    }
    if (before.length) {
      var f = fold('wofp-fold-numbers', ROWS.numbersTitle, ROWS.numbersSub, before);
      /* calorie density and per cup, which used to sit in the plan's At a glance box */
      try {
        var fb = JSON.parse(document.getElementById('wofpp-boot').textContent);
        var kg = Math.round(fb.kcalKg), cup = Math.round(fb.kcalCup);
        if (kg > 0 && cup > 0) {
          var p = document.createElement('p'); p.className = 'wofp-fold__facts';
          p.textContent = fill(ROWS.numbersFacts, { kg: kg.toLocaleString(), cup: cup });
          f.querySelector('.wofp-fold__body').insertBefore(p, f.querySelector('.wofp-fold__body').firstChild);
        }
      } catch (e) {}
    }
    if (faq) {
      var h = faq.querySelector('h2,h3');
      var n = faq.querySelectorAll('details').length;
      fold('wofp-fold-questions', h ? clean(h.textContent) : 'Questions', n ? fill(ROWS.questionsSub, { n: n }) : '', [faq]);
      if (h) h.classList.add('wofp-vh');
    }
  }
  var more = document.getElementById('wofp-more');
  if (more && more.firstElementChild && !document.getElementById('wofp-fold-rotate')) {
    var mk = Array.prototype.slice.call(more.firstElementChild.children).filter(function (k) { return k.tagName !== 'SCRIPT' && k.tagName !== 'STYLE'; });
    var np = document.getElementById('wofpm-np'), nw = document.getElementById('wofpm-nw');
    var sub = (np && nw) ? fill(ROWS.rotateSub, { np: clean(np.textContent), nw: clean(nw.textContent) }) : '';
    if (mk.length) fold('wofp-fold-rotate', ROWS.rotateTitle, sub, mk);
  }
  /* RETURNING CUSTOMERS (stage 7): someone who has ordered before gets the
     bowl and the plan as closed rows too, and the rotation picker open, so the
     page is buy box, a few rows, reviews, and other recipes to add. */
  var returning = false;
  try { returning = !!JSON.parse(document.getElementById('wofp-boot').textContent).returning; } catch (e) {}
  if (returning) {
    var bowl = document.getElementById('wofp-bowl');
    if (bowl && bowl.firstElementChild && !document.getElementById('wofp-fold-bowl')) {
      /* fold the bowl's whole two-column grid, not the two halves inside it:
         left in the grid, the row was squeezed into one column on desktop and
         the bowl and copy were clipped to an empty band (2026-10-22). */
      var bk = Array.prototype.slice.call(bowl.children).filter(function (k) { return k.tagName !== 'SCRIPT' && k.tagName !== 'STYLE'; });
      var nItems = bowl.querySelectorAll('.wofp-bowl__item').length;
      if (bk.length) fold('wofp-fold-bowl', ROWS.bowlTitle, nItems ? fill(ROWS.bowlSub, { n: nItems }) : ROWS.bowlSubPlain, bk);
    }
    var feed = document.getElementById('wofp-feed');
    if (feed && feed.firstElementChild && !document.getElementById('wofp-fold-plan')) {
      var fk = Array.prototype.slice.call(feed.firstElementChild.children).filter(function (k) { return k.tagName !== 'SCRIPT' && k.tagName !== 'STYLE' && k.tagName !== 'NOSCRIPT'; });
      if (fk.length) {
        var pf = fold('wofp-fold-plan', ROWS.planTitle, '', fk);
        var paintPlan = function () {
          var d = window.wofpDog ? window.wofpDog() : null;
          var nm = d && d.name ? d.name : '';
          pf.querySelector('.wofp-fold__t').textContent = nm ? fill(ROWS.planTitleFor, { name: nm }) : ROWS.planTitle;
          var v = document.getElementById('wofpp-who-v'), a = document.getElementById('wofpp-who-a');
          var sub = [v ? clean(v.textContent) : '', a ? clean(a.textContent) : ''].filter(Boolean).join(' \u00B7 ');
          var se = pf.querySelector('.wofp-fold__s');
          if (!se) { se = document.createElement('span'); se.className = 'wofp-fold__s'; pf.querySelector('.wofp-fold__tx').appendChild(se); }
          se.textContent = sub;
        };
        paintPlan();
        document.addEventListener('wyn:dog', function () { setTimeout(paintPlan, 80); });
      }
    }
    var rf = document.getElementById('wofp-fold-rotate');
    if (rf) rf.open = true;
  }
  /* a link into a closed row opens it first */
  function openFor(hash) {
    if (!hash || hash.length < 2) return;
    var t = null;
    try { t = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (e) {}
    if (!t) return;
    var d = t.closest ? t.closest('.wofp-fold') : null;
    if (d && !d.open) { d.open = true; setTimeout(function () { try { t.scrollIntoView({ block: 'start' }); } catch (e) {} }, 60); }
  }
  openFor(location.hash);
  window.addEventListener('hashchange', function () { openFor(location.hash); });
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href*="#"]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var i = href.indexOf('#');
    if (i < 0) return;
    var path = href.slice(0, i);
    if (path && path !== location.pathname && path !== location.pathname + location.search) return;
    openFor(href.slice(i));
  }, true);
})();

/* ---- THE STICKY BAR (stage 2) --------------------------------------------
   Phones and tablets only. It appears once the buy box's own Add to cart
   button has scrolled off the top of the screen, never while that button is
   visible, and steps aside whenever something else owns the bottom edge: the
   cart drawer, the Added sheet, the phone menu, the Fresh Rx next-steps panel,
   or the chat itself. Its numbers are painted by wofp-buy.js, the one owner of
   the math; its Add button presses the real one. The chat bubble is folded into
   the bar (wask.js hides the floating bubble while the bar is up). */
var bar = document.getElementById('wofp-bar');
var addBtn = document.getElementById('wofp-add');
if (bar && addBtn) {
  var narrow = window.matchMedia('(max-width:999.98px)');
  var BLOCK = ['#mini-cart[open]', '#wofpz.is-up', '#wofn-drawer:not([hidden])', '.wofn-rx', '#wask .wask-panel:not([hidden])'];
  var up = false, shown = false;
  function blocked() {
    for (var i = 0; i < BLOCK.length; i++) {
      var e = document.querySelector(BLOCK[i]);
      if (e && e.getBoundingClientRect().height > 0) return true;
    }
    return false;
  }
  function want() {
    if (!narrow.matches) return false;
    if (blocked()) return false;
    var r = addBtn.getBoundingClientRect();
    return r.bottom < 0;                 /* the real button is above the screen */
  }
  function paint() {
    var w = want();
    if (w && !shown) { shown = true; bar.hidden = false; }
    if (w !== up) {
      up = w;
      /* let the unhide paint once, so the slide actually runs */
      setTimeout(function () { bar.classList.toggle('is-up', up); document.documentElement.classList.toggle('wofp-bar-up', up); }, shown && w ? 20 : 0);
    }
  }
  var q = false;
  function queue() { if (q) return; q = true; requestAnimationFrame(function () { q = false; paint(); }); }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  if (narrow.addEventListener) narrow.addEventListener('change', queue);
  setInterval(function () { if (!document.hidden) paint(); }, 400);
  paint();

  var barAdd = document.getElementById('wofp-bar-add');
  if (barAdd) barAdd.addEventListener('click', function () {
    if (barAdd.classList.contains('is-busy')) return;
    addBtn.click();
  });
  var ask = document.getElementById('wofp-bar-ask');
  if (ask) ask.addEventListener('click', function () {
    var fab = document.querySelector('#wask .wask-fab');
    if (fab) { fab.click(); return; }
    var alt = document.querySelector('.wofn-ask');
    if (alt) alt.click();
  });
  if (!document.querySelector('#wask .wask-fab') && ask) ask.hidden = true;
}
})();